import CardRow from '../../../../components/CardRow/CardRow';
import CardRowCard from '../../../../components/CardRow/CardRowCard';
import React from 'react';

const GridComponent = ({ components }) => {
  const createGrid = (input) => {
    const output = [];
    for (let i = 0; i <= input.length - 1; i += 2) {
      const row = {
        left: input[i],
        right: input[i + 1] || null,
      };
      output.push(
        <CardRow key={i}>
          <CardRowCard>
            {row.left}
          </CardRowCard>
          <CardRowCard showBorder={!!row.right}>{row.right}</CardRowCard>
        </CardRow>,
      );
    }
    return output;
  };

  return createGrid(components);
};

export default GridComponent;
